<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
  <span
    class="bold-hack"
    :class="{ 'bold-hack--compact': compact }"
    :title="text"
    >{{ text }}</span
  >
</template>

<script setup lang="ts">
defineProps<{
  text: string
  compact?: boolean
}>()
</script>

<style scoped>
.bold-hack {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}

.bold-hack::after {
  content: attr(title);
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}

.bold-hack--compact::after {
  font-size: 0.75rem;
  line-height: 1rem;
}

@media (min-width: theme('screens.lg')) {
  .bold-hack--compact::after {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
</style>
